import { Box, Typography } from '@mui/material';
import Paper from '@mui/material/Paper';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ContentContainer } from '../../components/ContentContainer';
import { GenericToolbar } from '../../components/GenericToolbar/GenericToolbar';
import { isRecordFound, useSelectedOrganizationData } from '../../hooks/data-hooks';
import { AddDevice } from '../../components/AddDevice/AddDevice';
import { useSiteProfileData } from '../../data/DataProviders/SiteProfileDataProvider';
import { isDataLoaded } from '../../types';
import { pushAppRoute } from '../../data/domain/route-manager';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';
import { useDeviceMaster } from '../../data/DataProviders/DeviceMasterProvider';
import { DataIndicators } from '../../components/DataIndicators';
import { useDispatch, useSelector } from 'react-redux';
import { Selectors } from '../../selectors';
import { ConfirmationPopUp } from '../../components/ConfirmationPopUp/ConfirmationPopUp';
import { Actions } from '../../actions';
import { HeaderInfo } from '../../components/HeaderInfo/HeaderInfo';
import { DeviceBlueprintProvider } from '../../data/DataProviders/DeviceBlueprintProvider';

export const AddDeviceProfile: React.FC = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const selectedOrganization = useSelectedOrganizationData();
    const deviceRegistrationState = useSelector(Selectors.SierraDevice.deviceRegistration);
    const orgId = isRecordFound(selectedOrganization) ? selectedOrganization.value.id : '';
    const orgName = isRecordFound(selectedOrganization) ? selectedOrganization.value.name : '';
    const currentAppRoute = useCurrentAppRoute();
    const deviceMasterData = useDeviceMaster();
    const [deviceTypeList, setDeviceTypeList] = React.useState<any[]>([]);
    const [pxdbdeviceList, setPxdbdeviceList] = React.useState<any[]>([]);
    const siteData = useSiteProfileData();
    //const childDeviceList = deviceRegistrationState.selectedChildDevices;

    const headerSubTitle = isDataLoaded(siteData) ? siteData.value.name : '';
    const handleClose = (): void => {
        dispatch(Actions.SierraDevices.sierraGatewayDeviceRegistrationUnmounted());
        if ('locationId' in currentAppRoute && 'siteId' in currentAppRoute)
            pushAppRoute(history, {
                type: 'SiteProfile',
                orgId: orgId,
                locationId: currentAppRoute.locationId,
                siteId: currentAppRoute.siteId,
            });
    };
    const onDeviceCancel = (): void => {
        if (currentAppRoute.type === 'AddDevice')
            pushAppRoute(history, {
                type: 'SiteProfile',
                orgId: currentAppRoute.orgId,
                locationId: currentAppRoute.locationId,
                siteId: currentAppRoute.siteId,
            });
    };
    useEffect(() => {
        deviceMasterData.getDeviceTypeMasterData(orgName, 'gateway');
        deviceMasterData.getDevicesMasterData(orgName, 'pxdb-device-types');
        dispatch(Actions.SierraDevices.sierraGatewayDeviceRegistrationUnmounted());
    }, []); //eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (isDataLoaded(deviceMasterData.deviceTypeData) && deviceMasterData.rowKey === 'gateway') {
            setDeviceTypeList(deviceMasterData.deviceTypeData.value);
        }
        if (isDataLoaded(deviceMasterData.devicesData) && deviceMasterData.pxdbRowKey === 'pxdb-device-types') {
            setPxdbdeviceList(deviceMasterData.devicesData.value);
        }
    }, [deviceMasterData]);

    return (
        <>
            <GenericToolbar
                showBackButton
                backButtonOnClick={(): void => {
                    if (currentAppRoute.type === 'AddDevice')
                        pushAppRoute(history, {
                            type: 'SiteProfile',
                            orgId: currentAppRoute.orgId,
                            locationId: currentAppRoute.locationId,
                            siteId: currentAppRoute.siteId,
                        });
                }}
                title="Add Connected Device"
                subtitle={headerSubTitle}
            />
            <ContentContainer>
                <Paper style={{ padding: 56 }}>
                    <HeaderInfo title="Connected Device Information" entity="to add a Connected Device" />

                    {isDataLoaded(siteData) && (
                        <Box>
                            {!isDataLoaded(deviceMasterData.deviceTypeData) && (
                                <DataIndicators
                                    errorMessage="Record not found"
                                    emptyMessage="Record not found"
                                    inline
                                    data={deviceMasterData.deviceTypeData}
                                    emptyIcon="Devices"
                                    isEmpty={false}
                                    isDetailedInfo={false}
                                />
                            )}
                            {isDataLoaded(deviceMasterData.deviceTypeData) && (
                                <DeviceBlueprintProvider>
                                    <AddDevice
                                        onCancel={onDeviceCancel}
                                        siteId={siteData.value.id}
                                        deviceTypeList={deviceTypeList}
                                        organizationName={orgName}
                                        device={'gateway'}
                                        pxdbDeviceTypeList={pxdbdeviceList}
                                    />
                                </DeviceBlueprintProvider>
                            )}
                        </Box>
                    )}
                    {deviceRegistrationState.gatewaySuccess && (
                        <ConfirmationPopUp
                            title="Submission Successful!"
                            body={
                                <>
                                    <Typography variant="subtitle1">
                                        Your Connected Device is being remotely configured.
                                    </Typography>
                                    <Typography variant="subtitle1">
                                        Please allow 10 to 90 minutes for this configuration to be downloaded to your
                                        Gateway.
                                    </Typography>
                                    <Typography variant="subtitle1">
                                        The total configuration time is dependent on your Gateway&apos;s cellular signal
                                        strength.
                                    </Typography>
                                </>
                            }
                            okButtonText={'OK'}
                            show={deviceRegistrationState.gatewaySuccess}
                            handleOk={handleClose}
                            okButtonShow={true}
                            width="xs"
                        ></ConfirmationPopUp>
                    )}
                </Paper>
            </ContentContainer>
        </>
    );
};
